/**
* Service Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-slider' ).length ) {
        $( '.service-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            autoWidth: true,
            gap: '1rem',
            pagination: false,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );

          const bar = splide.root.querySelector( '.progress-bar' );

          splide.on( 'mounted move', function() {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
